import React from 'react';
import styled, { css } from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

const showEllipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default styled(({ ellipsis, primaryColor, ...rest }) => <div {...rest} />)`
  color: ${({primaryColor}) => primaryColor ?? lightGrey3Color};
  font-size: 0.8rem;
  ${({ ellipsis }) => ellipsis && showEllipsis}
`;
